<template>
  <div id="app">
    <div id="devMode" v-if="devMode">
      Entorno de prueba
    </div>
    <component :is='layout' :key="currentTimestamp">
    </component>
  </div>
</template>

<script>
const defaultLayout = 'default';

export default {
  name: 'app',
  computed: {
    layout() {
      return `${this.$route.meta.layout || defaultLayout}-layout`;
    },
    locale() {
      return this.$i18n.locale;
    },
    currentRouteName() {
      return this.$route.name;
    }
  },
  watch: {
    locale() {
      this.currentTimestamp = new Date().getTime();
    },
  },
  data() {
    return {
      devMode: false,
      currentTimestamp: new Date().getTime(),
    };
  },
  created() {
    // if (window.location.hostname.includes('dev.lifeon.cl')) {
    //   this.devMode = true;
    // }
  },
  methods: {
  }
};
</script>

<style>
#devMode {
  margin-bottom: 50px;
  background-color: red;
  width: 100%;
  height: 50px;
  font-size: 20px;
  font-weight: 30px;
  text-align: center;
  color: white;
  line-height: 50px;
  font-weight: bold;
}
</style>
